import { useState, useEffect } from "react";
import {
  fetchListaConfiguracion,
  fetchOpcionesMenu,
} from "../../services/parameter.service";

const useFooterMenus = () => {
  const [footerGenerales, setFooterGenerales] = useState([]);
  const [footerNormatividad, setFooterNormatividad] = useState([]);
  const [lineaAtencionInfo, setLineaAtencionInfo] = useState({});
  const [pqrInfo, setPqrInfo] = useState({});
  const [socialMedia, setSocialMeddia] = useState({});

  const [isGeneralesLoading, setIsGeneralesLoading] = useState(false);
  const [isNormatividadLoading, setIsNormatividadLoading] = useState(false);

  const getFooterGenerales = async () => {
    setIsGeneralesLoading(true);

    try {
      const response = await fetchOpcionesMenu({
        App: "SI",
        Publica: "SI",
        Tipo: "FOOTER-GENERALES",
      });

      setFooterGenerales(response.data.list);
      setIsGeneralesLoading(false);
    } catch (error) {
      console.error(error);
      setIsGeneralesLoading(false);
    }
  };

  const getFooterNormatividad = async () => {
    setIsNormatividadLoading(true);

    try {
      const response = await fetchOpcionesMenu({
        App: "SI",
        Publica: "SI",
        Tipo: "FOOTER-NORMATIVA",
      });

      setFooterNormatividad(response.data.list);
      setIsNormatividadLoading(false);
    } catch (error) {
      console.error(error);
      setIsNormatividadLoading(false);
    }
  };

  const getLineaAtencion = async () => {
    try {
      const texto = await fetchListaConfiguracion({
        key: "LINEA_ATENCION_TEXTO",
      });

      const tel = await fetchListaConfiguracion({
        key: "LINEA_ATENCION_TEL",
      });

      setLineaAtencionInfo((prevState) => {
        return {
          ...prevState,
          texto: texto.data.list[0]?.value,
          tel: tel.data.list[0]?.value,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getPqrInfo = async () => {
    try {
      const pqrTexto = await fetchListaConfiguracion({ key: "PQR_TEXTO" });
      const pqrEmail = await fetchListaConfiguracion({ key: "PQR_EMAIL" });

      setPqrInfo((prevState) => {
        return {
          ...prevState,
          texto: pqrTexto.data.list[0]?.value,
          email: pqrEmail.data.list[0]?.value,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getSocialMedia = async () => {
    try {
      const facebook = await fetchListaConfiguracion({ key: "FACEBOOK" });
      const twitter = await fetchListaConfiguracion({ key: "TWITTER" });

      setSocialMeddia((prevState) => {
        return {
          ...prevState,
          facebook: facebook.data.list[0]?.value,
          twitter: twitter.data.list[0]?.value,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getFooterGenerales();
    getFooterNormatividad();
    getLineaAtencion();
    getPqrInfo();
    getSocialMedia();
  }, []);

  return {
    footerGenerales,
    footerNormatividad,
    isGeneralesLoading,
    isNormatividadLoading,
    lineaAtencionInfo,
    pqrInfo,
    socialMedia,
  };
};

export default useFooterMenus;
